import { Component, OnInit, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material/dialog";
import { AdsService } from "src/app/core/services/ads.service";
import { SiteService } from "src/app/core/services/site.service";
import { Clipboard } from '@angular/cdk/clipboard';
import { AppConfig } from "src/app/configs/app.config";

@Component({
  selector: "app-action-preview",
  templateUrl: "./action-preview.component.html",
  styleUrls: ["./action-preview.component.scss"],
})
export class ActionPreviewComponent implements OnInit {

  priorityAudit:boolean =false;
  tag_url:string;
  disablecancel = false;

  selectedPostalCodes: Array<any> = [];
  readonly imgPath: string;

  seedFaqs = [
    {
      question: 'Is seed creation part of the audience or advertiser setup? ',
      answer: 'You can create a seed at the advertiser level and attach it to your Insertion Orders. You can create multiple seeds and use them across various campaigns depending on the campaign goals.' ,
    },
    {
      question: 'Am I required to create a seed? ',
      answer: 'Yes. Without a seed, the platform will not be able to calculate relevance which is a powerful metric that measures the overlap between your seed and your targeting. Relevance is the metric that effectively scores numerous dimensions for your ideal customer.',
    },
    {
      question: "What if I don't have enough data or any data to create a seed?",
      answer:'Don\'t worry! Think of your seed as a dynamic entity whose data changes over time. Even if you don\'t have enough data to start, you can still create a seed and keep building it as more data sources become available. You don\'t need a lot of data for seeds to work because seeds allow you to put even a few thousand user sign-ups to work.'
    },
    {
      question: "How is seed different from audience?",
      answer:'You would use an audience for targeting. It defines the universe in which your campaign or ad group runs. Your seed is a way for you and our platform to work together to prioritize people within that universe that are great for the success of your brand. Audiences are meant to represent your targeting universe, seeds are meant to be a precise truth set of customers you want more of. For example, you are selling sports shoes online. Your seed is people who bought sports shoes in the last 30 days. Your audience might be urban millenials. We use the behaviors and attributes of past purchasers to find which millenials are most likely to convert and pay the best price for those impressions.'
    },
    {
      question:'Will I have to manually establish my default seed?',
      answer:'The first seed you create will be considered your default seed. If you have more than one seed, you can change your default at any time.'
    },
    {
      question:'What should I do if I don\'t have any conversion data or want to reach a totally new demographic?',
      answer:'You can start by testing out how audiences react and refine a data set that represents true people that engage with your brand. To do so you should start with a proxy action, such as a homepage visit. For example, create an empty pixel and add in a third-party data segment or other data type that represents your new customer. As the pixel gets attributed conversions, the seed will automatically prioritize the new first-party data as it comes in.'
    },
    {
      question:'If I do measurement offline, can I use this data as a seed?',
      answer:'Yes! If you track any offline brand interactions, for example, through CRM lists or other first-party data collection methods, you can push them to the platform as onboarded first-party data.'
    },
    {
      question:'Do I need seeds if I run exclusively CTV campaigns?',
      answer:'Yes. Seeds help you understand the quality of your reach, even on devices without deterministic attribution. The graph helps find people across households and devices.'
    },
    {
      question:'Do I need seeds if I primarily run reach campaigns?',
      answer:'Yes. Seeds can help you find the best quality reach. Even if you\'re looking to target large demographic, behavioral, or interest categories. The seed will be used to prioritize impressions that share similar behaviors within these large audiences and help drive them down the funnel. Therefore, if you have any first-party conversion data, you should use it as seed.'
    }

  ];


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ActionPreviewComponent>,
    private SiteService : SiteService,
    private adsService : AdsService,
    private clipboard: Clipboard
  ) {
    this.imgPath = AppConfig.POPUP_LOGO;
  }

  ngOnInit(): void {
    this.dialogRef.updatePosition({
      top: "25em",
      /** Override for the dialogs bottom position. */
      left: "40%",
      /** Override for the dialogs right position. */
      right: "10em",
    });
    if(this.data.action == 'generateUrl'){
      this.generateURL(this.data['items'], this.data['type'])
    }
    if(this.data.disablecancel){
      this.disablecancel = this.data.disablecancel
    }
    console.log(this.data);
  }

  generateURL(data, type){
    if(type == 'website'){
    this.SiteService.generateURL(data.id).subscribe(res => {
       this.tag_url = res.data['url']
      },() => {},() => {
      });
    }
    else if (type == 'ads'){
      this.adsService.generateURL(data.id).subscribe(res => {
        this.tag_url = res.data['url']
        },() => {},() => {
        });
    }

  }

  copyToClipboard(tag_url) {
    this.clipboard.copy(tag_url);
  }

  closeModel(saveData: boolean) {
    this.dialogRef.close({
      event: "save",
      save: saveData,
      priorityAudit:this.priorityAudit,
      selectedPostalCodes: this.selectedPostalCodes
    });
  }

  closeModelURL(saveData: boolean){
    this.dialogRef.close({
      event: "save",
      save: saveData,
    });
  }
}
